<template>
  <div v-if="isCheckAgeNeeded" className="checkout" v-bind:class="{ 'error': showError }">
    <label htmlFor="checkAge" className="form-check-label">{{ $translate('KrauseSohn::Template.checkout18Check')
      }}</label>
  </div>
</template>
<script>
import { mapState } from "vuex";
import NotificationService from "../../services/NotificationService";
import TranslationService from "../../services/TranslationService";

export default {
  name: "check-age",
  data()
  {
    return {
      checkAge: false,
      isSet: false
    }
  },

  computed:
      {
        isCheckAgeNeeded()
        {
          if ((this.shippingProfileId == parseInt(App.configKS.checkout.checkoutShippingSpeditionSilvester)) ||
              (this.shippingProfileId == 10) || (this.shippingProfileId == 7))
          {
            return true;
          }
          return false;
        },
        ...mapState({
          shippingProfileId: state => state.checkout.shipping.shippingProfileId
        })
      }
}
</script>
